import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { MapPin, Phone, Mail } from 'lucide-react';

export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <h4 className="text-lg font-bold tracking-tight mb-3">Alphaprofiles</h4>
            <p className="text-slate-400 text-sm leading-relaxed">
              {t('footer.description') || 'Uw partner voor metalen profielsystemen.'}
            </p>
            <p className="text-slate-500 text-xs mt-4">BTW: BE0759.365.124</p>
          </div>

          {/* Address */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-slate-400 mb-4">{t('contact.address')}</h4>
            <div className="flex items-start gap-3 text-slate-300 text-sm leading-relaxed">
              <MapPin className="w-4 h-4 text-slate-500 flex-shrink-0 mt-0.5" />
              <span>
                Elektronikalaan 1<br />
                2610 Antwerpen<br />
                Belgie
              </span>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-slate-400 mb-4">{t('contact.title')}</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-slate-300 text-sm">
                <Phone className="w-4 h-4 text-slate-500 flex-shrink-0" />
                <a href="tel:+32475223211" className="hover:text-white transition-colors">+32 475 22 32 11</a>
              </div>
              <div className="flex items-center gap-3 text-slate-300 text-sm">
                <Mail className="w-4 h-4 text-slate-500 flex-shrink-0" />
                <a href="mailto:info@alphaprofiles.com" className="hover:text-white transition-colors">info@alphaprofiles.com</a>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-slate-400 mb-4">Navigatie</h4>
            <div className="space-y-2">
              <Link to="/products" className="block text-slate-300 text-sm hover:text-white transition-colors">{t('nav.products')}</Link>
              <Link to="/about" className="block text-slate-300 text-sm hover:text-white transition-colors">{t('nav.about')}</Link>
              <Link to="/contact" className="block text-slate-300 text-sm hover:text-white transition-colors">{t('nav.contact')}</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-2">
            <p className="text-slate-500 text-xs">
              &copy; {currentYear} Alphaprofiles. All rights reserved.
            </p>
            <Link to="/beheer" className="text-slate-600 text-xs hover:text-slate-400 transition-colors">
              Privacy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
